import { FOCUS_FIRST_NEW_ITEM_DONE } from "./const";

function action() {
  return {
    type: FOCUS_FIRST_NEW_ITEM_DONE,
  };
}

export default action;
